import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import {
  GRAPH_PANEL_IMPORTS,
  GraphPanelComponent,
} from '../../../../panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from '../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-co2-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class Co2GraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.TotalCo2Graph;
  public override unit = DisplayUnit.Kg;

  public override config: IGraphConfig = {
    sortOrder: [GraphType.ElectricityEmission, GraphType.GasEmission],
    getGraphTypeDataset: this.getGraphTypeDataset,
  };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.ElectricityEmission:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Uitstoot electriciteit',
          Color.Red,
          DisplayUnit.Kg,
        );
      case GraphType.GasEmission:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Uitstoot gas', Color.Orange, DisplayUnit.Kg);
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
